import { makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { IPenaltiesToggleViewModel } from '@shared/types/mobx/features/osiAccruals';
import { notifications } from '@shared/utils/notifications';
import logger from 'js-logger';
import api from '@app/api';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';

@injectable()
export class PenaltiesToggleViewModel implements IPenaltiesToggleViewModel {
  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);
  }

  get isFinesEnabled(): boolean {
    return this.osiModule.osiInfo?.createFine ?? false;
  }

  toggleFines = async () => {
    try {
      if (!this.osiModule.osiInfo) return;

      const payload = this.osiModule.osiInfo;

      payload.createFine = !payload.createFine;

      await api.OsiUpdate(payload?.id, payload);
      await this.osiModule.refreshOsi();

      notifications.success();
    } catch (e) {
      logger.error(e);
      notifications.error();
    }
  };
}
